<script setup>
const { align = 'left' } = defineProps({
    align: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex h-full items-center gap-2 p-4"
        :class="{
            'justify-start text-left': align === 'left',
            'justify-center text-center': align === 'center',
            'justify-end text-right': align === 'right',
        }"
    >
        <slot />
    </div>
</template>
